// extracted by mini-css-extract-plugin
module.exports = {"message":"TitleBox_message__54Eo0","recommend":"TitleBox_recommend__gS9ly"};